import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse
} from "@angular/common/http";
import { catchError } from "rxjs/operators";
// import { throwError } from "rxjs";
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import {_throw} from 'rxjs/observable/throw'
import { Injectable } from "@angular/core";

import { ErrorDialogComponent } from "./dialogs/error-dialog/error-dialog.component";
import { DialogsService } from "./dialogs/dialogs.service";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "./auth/auth.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
      // private dialog: MatDialog,
              private errorService: DialogsService, private translate: TranslateService, private authSrv:AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const self = this;
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        function getDefault(){
            self.translate.get('E_1').subscribe((res: string) => {
                errorMessage = res;
                self.errorService.throwError(errorMessage);
            })
        }

        let errorMessage = "";
        // console.log('error int', error.error);
        if (error.error.messageId) {


            self.translate.get(error.error.messageId, error.error.messageParams).subscribe((res: string) => {
                errorMessage = res;
                if (errorMessage === error.error.messageId) {
                    getDefault()
                } else {
                  self.errorService.throwError(errorMessage);
                }
                if (error.error.messageId == "609") {
                    self.authSrv.logout();
                }
            });
        }
        else if (error.error.message) {
          errorMessage = error.error.message;
            self.errorService.throwError(errorMessage);
        }
        return _throw(error);
      })
    );
  }
}

